<script lang="ts" setup>
withDefaults(
  defineProps<{
    title: string
    subtitle?: string
    description?: string
    titleColor?: string
    background: {
      src: string
      alt: string
    }
    maskType: 'tilted' | 'rounded'
  }>(),
  { subtitle: '' },
)

const slots = defineSlots<{
  description?: (props: object) => any
}>()
</script>

<template>
  <AlPadding side="none" class="mb-20 overflow-x-hidden">
    <header
      class="grid w-full grid-rows-1 text-shadow"
      :class="[
        maskType === 'rounded' && 'sm:aspect-[1434/768]',
        maskType === 'tilted' && 'sm:aspect-[1383/785]',
      ]"
    >
      <img
        :src="background.src"
        :alt="background.alt"
        class="h-full w-full object-cover [grid-area:1/1] max-sm:[mask-size:cover]"
        :class="[maskType === 'rounded' && 'mask-rounded', maskType === 'tilted' && 'mask-tilted']"
      />
      <AlPadding
        wrapper-class="[grid-area:1/1] flex flex-col justify-end flex-wrap"
        class="relative mt-4 max-w-[90%] pb-[5%] sm:max-w-[75%]"
        :limit-width="false"
        :class="{ 'mb-4 sm:mb-12': maskType === 'rounded', 'mb-4': maskType === 'tilted' }"
      >
        <h1
          class="font-sans-header text-2xl uppercase sm:text-3xl lg:text-4xl xl:text-6xl"
          :class="[titleColor ?? 'text-white']"
        >
          {{ title }}
        </h1>
        <div v-if="subtitle" class="md:mb-4 xl:mb-8">
          <h2 class="font-sans-header text-base uppercase text-white lg:text-xl xl:text-3xl">
            {{ subtitle }}
          </h2>
        </div>
        <div v-if="slots.description || description" class="mt-2">
          <slot name="description">
            <p class="text-base text-white md:text-lg">{{ description }}</p>
          </slot>
        </div>
      </AlPadding>
    </header>
  </AlPadding>
</template>
